function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SaintHelenaFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_1501",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_1501)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#2E42A5"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_1501",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_1501)",
      children: [/*#__PURE__*/_jsx("mask", {
        id: "mask2_621_1501",
        style: {
          maskType: 'luminance'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "3",
        width: "14",
        height: "11",
        children: /*#__PURE__*/_jsx("rect", {
          y: "3",
          width: "13.5",
          height: "10.5",
          fill: "white"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#mask2_621_1501)",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M-1.5032 12.7499L1.46751 14.0528L13.5674 4.41656L15.1344 2.48041L11.9576 2.04494L7.02238 6.19746L3.05 8.99528L-1.5032 12.7499Z",
          fill: "#F7FCFF"
        }), /*#__PURE__*/_jsx("path", {
          d: "M-1.09651 13.6627L0.416929 14.4188L14.5717 2.30054H12.4466L-1.09651 13.6627Z",
          fill: "#F50100"
        }), /*#__PURE__*/_jsx("path", {
          d: "M15.0032 12.7499L12.0325 14.0528L-0.067421 4.41656L-1.6344 2.48041L1.54235 2.04494L6.4776 6.19746L10.45 8.99528L15.0032 12.7499Z",
          fill: "#F7FCFF"
        }), /*#__PURE__*/_jsx("path", {
          d: "M14.9018 13.405L13.3884 14.1611L7.36114 8.9726L5.57419 8.39291L-1.78518 2.48701H0.339865L7.6951 8.25273L9.64882 8.94784L14.9018 13.405Z",
          fill: "#F50100"
        }), /*#__PURE__*/_jsxs("mask", {
          id: "path-9-outside-1_621_1501",
          maskUnits: "userSpaceOnUse",
          x: "-1",
          y: "2",
          width: "16",
          height: "13",
          fill: "black",
          children: [/*#__PURE__*/_jsx("rect", {
            fill: "white",
            x: "-1",
            y: "2",
            width: "16",
            height: "13"
          }), /*#__PURE__*/_jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.48838 3H5.98838V7.5H0V9H5.98838V13.5H7.48838V9H13.5V7.5H7.48838V3Z"
          })]
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.48838 3H5.98838V7.5H0V9H5.98838V13.5H7.48838V9H13.5V7.5H7.48838V3Z",
          fill: "#F50100"
        }), /*#__PURE__*/_jsx("path", {
          d: "M5.98838 3V2.25H5.23838V3H5.98838ZM7.48838 3H8.23838V2.25H7.48838V3ZM5.98838 7.5V8.25H6.73838V7.5H5.98838ZM0 7.5V6.75H-0.75V7.5H0ZM0 9H-0.75V9.75H0V9ZM5.98838 9H6.73838V8.25H5.98838V9ZM5.98838 13.5H5.23838V14.25H5.98838V13.5ZM7.48838 13.5V14.25H8.23838V13.5H7.48838ZM7.48838 9V8.25H6.73838V9H7.48838ZM13.5 9V9.75H14.25V9H13.5ZM13.5 7.5H14.25V6.75H13.5V7.5ZM7.48838 7.5H6.73838V8.25H7.48838V7.5ZM5.98838 3.75H7.48838V2.25H5.98838V3.75ZM6.73838 7.5V3H5.23838V7.5H6.73838ZM0 8.25H5.98838V6.75H0V8.25ZM0.75 9V7.5H-0.75V9H0.75ZM5.98838 8.25H0V9.75H5.98838V8.25ZM6.73838 13.5V9H5.23838V13.5H6.73838ZM7.48838 12.75H5.98838V14.25H7.48838V12.75ZM6.73838 9V13.5H8.23838V9H6.73838ZM13.5 8.25H7.48838V9.75H13.5V8.25ZM12.75 7.5V9H14.25V7.5H12.75ZM7.48838 8.25H13.5V6.75H7.48838V8.25ZM6.73838 3V7.5H8.23838V3H6.73838Z",
          fill: "#F7FCFF",
          mask: "url(#path-9-outside-1_621_1501)"
        })]
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.0342 10.4044H14.9092V10.5294C14.9092 10.9205 14.9074 11.3031 14.9056 11.6763C14.9015 12.564 14.8976 13.3982 14.9186 14.1646C14.9483 15.2532 15.0281 16.2162 15.2314 17.0161C15.4348 17.8168 15.7647 18.4652 16.3027 18.9122C16.8419 19.3601 17.574 19.5926 18.5552 19.5926C19.5428 19.5926 20.2954 19.3048 20.8587 18.7919C21.4194 18.2814 21.7811 17.5582 22.0091 16.7068C22.464 15.0083 22.3981 12.7535 22.2708 10.5223L22.2641 10.4044H22.146H15.0342Z",
        fill: "#B7E1FF",
        stroke: "#F7FCFF",
        strokeWidth: "0.25"
      }), /*#__PURE__*/_jsx("mask", {
        id: "mask3_621_1501",
        style: {
          maskType: 'luminance'
        },
        maskUnits: "userSpaceOnUse",
        x: "14",
        y: "10",
        width: "9",
        height: "10",
        children: /*#__PURE__*/_jsx("path", {
          d: "M15.0342 10.4044H14.9092V10.5294C14.9092 10.9205 14.9074 11.3031 14.9056 11.6763C14.9015 12.564 14.8976 13.3982 14.9186 14.1646C14.9483 15.2532 15.0281 16.2162 15.2314 17.0161C15.4348 17.8168 15.7647 18.4652 16.3027 18.9122C16.8419 19.3601 17.574 19.5926 18.5552 19.5926C19.5428 19.5926 20.2954 19.3048 20.8587 18.7919C21.4194 18.2814 21.7811 17.5582 22.0091 16.7068C22.464 15.0083 22.3981 12.7535 22.2708 10.5223L22.2641 10.4044H22.146H15.0342Z",
          fill: "white",
          stroke: "white",
          strokeWidth: "0.25"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#mask3_621_1501)",
        children: [/*#__PURE__*/_jsx("rect", {
          x: "16.8",
          y: "17.7",
          width: "5.4",
          height: "1.8",
          fill: "#2E42A5"
        }), /*#__PURE__*/_jsx("g", {
          filter: "url(#filter0_d_621_1501)",
          children: /*#__PURE__*/_jsx("rect", {
            x: "13.2",
            y: "8.70001",
            width: "10.8",
            height: "5.4",
            fill: "#FDFF00"
          })
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.6 13.56C19.2959 13.56 19.86 12.9959 19.86 12.3C19.86 11.6041 19.2959 11.04 18.6 11.04C17.9041 11.04 17.34 11.6041 17.34 12.3C17.34 12.9959 17.9041 13.56 18.6 13.56Z",
          fill: "#272727"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.1059 15.6178L15.9098 14.8773C15.9098 14.8773 16.9958 14.7681 17.1238 15.0078C17.2519 15.2475 17.1758 14.8971 17.3802 15.4474C17.5845 15.9977 17.6654 15.2109 17.7778 15.9977C17.8902 16.7844 17.9853 17.0559 17.9853 17.2389C17.9853 17.4219 19.0088 17.9672 18.6162 18.3428C18.2236 18.7183 18.2062 19.5835 18.2062 19.8314C18.2062 20.0793 18.1754 20.1904 17.7778 20.1349C17.3802 20.0793 16.8966 20.2773 16.8 20.2773C16.7034 20.2773 15.5376 20.0397 15.5376 19.5507C15.5376 19.0618 15.1059 15.6178 15.1059 15.6178Z",
          fill: "#CE6201"
        })]
      })]
    })]
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsxs("filter", {
      id: "filter0_d_621_1501",
      x: "13.2",
      y: "8.70001",
      width: "10.8",
      height: "5.64999",
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/*#__PURE__*/_jsx("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/_jsx("feOffset", {
        dy: "0.25"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_621_1501"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow_621_1501",
        result: "shape"
      })]
    })
  })]
}));
//# sourceMappingURL=SaintHelena.js.map